let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("djEoP")).then(() => parcelRequire('d2zX5'));